import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { getDateTime } from '@sda/utils/date';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Beacon } from '@sda/interfaces/beacon';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startAddBeacon = createAction<Beacon>(`${Reducers.BEACONS}/startAddBeacon`);
export const startCancelBeacon = createAction<string>(`${Reducers.BEACONS}/startCancelBeacon`);
export const startUpdateBeacon = createAction<Beacon & FetchDataType>(`${Reducers.BEACONS}/startUpdateBeacon`);
export const startShareBeacon = createAction<{ beaconId: string, email?: string, connectionId?: string }>(`${Reducers.BEACONS}/startShareBeacon`);
export const startShareBeaconLink = createAction<string>(`${Reducers.BEACONS}/startShareBeaconLink`);
export const startAddBeaconImpression = createAction<string>(`${Reducers.BEACONS}/startAddBeaconImpression`);
export const startSetBeaconFeaturedStatus = createAction<{ showCallId: string, isFeatured: boolean }>(`${Reducers.BEACONS}/startSetBeaconFeaturedStatus`);

export const beaconAdapter = createEntityAdapter<Beacon & FetchDataType>({
  sortComparer: (a, b) => getDateTime(a.startDate).toMillis() - getDateTime(b.startDate).toMillis(),
});

const beaconsSlice = createSlice({
  initialState: beaconAdapter.getInitialState(),
  name: Reducers.BEACONS,
  reducers: {
    ...extractSharedActions(beaconAdapter),
    upsertBeacons: (state, action) => {
      state.status = true;

      beaconAdapter.upsertMany(state, action);
    },
  },
});

export const {
  upsertBeacons, addOne: addBeacon, updateOne: updateBeacon,
} = beaconsSlice.actions;

export default beaconsSlice.reducer;
